import toast from 'react-hot-toast';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { CircularProgress } from '@mui/material';

export const successToaster = (message) => {
    toast(message,{
        icon: <CheckRoundedIcon sx={{
            color: "green"
        }} />,
    })
}

export const errorToaster = (message) => {
    toast(message,{
        icon: <ErrorOutlineIcon sx={{
            color: "red"
        }} />,
    })
}

export const warningToaster = (message) => {
    toast(message,{
        icon: <ReportProblemOutlinedIcon sx={{
            color: "yellow"
        }} />,
    })
}

export const loadingToaster = (message) => {
    toast(message,{
        icon: <CircularProgress />,
    })
}